import Icon from '@ant-design/icons';
import classNames from 'classnames';

import GuideSvg from '@/components/Icon/svgs/guide.svg';

import type { ExamplePopoverComponentProps } from '../example-popover';
import ExamplePopover from '../example-popover';
import LearnMore from '../learn-more';
import styles from './index.less';

export enum TitleStyleType {
  h1 = 'h1',
  h2 = 'h2',
  h3 = 'h3'
}

interface TitleDescriptionProps {
  title: React.ReactNode;
  desc?: React.ReactNode;
  descUrl?: string;
  id?: string;
  className?: string;
  headerType?: TitleStyleType;
  titleClassName?: string;
  children?: React.ReactNode;
  popOverPages?: ExamplePopoverComponentProps;
}

export default function TitleDescription(props: TitleDescriptionProps): JSX.Element {
  const {
    title,
    desc,
    descUrl,
    children,
    className,
    titleClassName,
    popOverPages,
    headerType = TitleStyleType.h2,
    id
  } = props;

  return (
    <div className={classNames(styles.container, className)} id={id}>
      <div className={styles.headerTitle}>
        {headerType === TitleStyleType.h1 && (
          <h1 className={classNames(styles.title, titleClassName)}>{title}</h1>
        )}
        {headerType === TitleStyleType.h2 && (
          <h2 className={classNames(styles.title, titleClassName)}>{title}</h2>
        )}
        {headerType === TitleStyleType.h3 && (
          <h3 className={classNames(styles.title, titleClassName)}>{title}</h3>
        )}
        {children}
      </div>
      {desc && (
        <div className={styles.desc}>
          <span>
            <div className={styles.descTitle}>
              {desc}
              {descUrl ? ' ' : null}
              <LearnMore url={descUrl} />
            </div>
            {popOverPages?.pages?.length ? (
              <div className={styles.popoverIcon}>
                <ExamplePopover {...popOverPages}>
                  <Icon component={GuideSvg} />
                </ExamplePopover>
              </div>
            ) : null}
          </span>
        </div>
      )}
    </div>
  );
}
